import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ViewMode, FileExplorerFilters, FileItem } from "../types";

export interface Tab {
  value: string;
  label: string;
  isCustom?: boolean;
}

interface FileExplorerUiState {
  viewMode: ViewMode;
  showFilters: boolean;
  filters: FileExplorerFilters;
  selectedFile: FileItem | null;
  activeTab: string;
  itemsPerPage: number;
  currentPage: number;
  customTabs: Tab[];
  setViewMode: (mode: ViewMode) => void;
  setShowFilters: (show: boolean) => void;
  setFilters: (filters: FileExplorerFilters) => void;
  setSelectedFile: (file: FileItem | null) => void;
  setActiveTab: (tab: string) => void;
  setItemsPerPage: (items: number) => void;
  setCurrentPage: (page: number) => void;
  resetFilters: () => void;
  addCustomTab: (tab: Tab) => void;
  removeCustomTab: (tabValue: string) => void;
}

const defaultFilters: FileExplorerFilters = {
  tags: [],
};

export const useFileExplorerUi = create<FileExplorerUiState>()(
  persist(
    (set) => ({
      viewMode: "gallery",
      showFilters: false,
      filters: defaultFilters,
      selectedFile: null,
      activeTab: "company-files",
      itemsPerPage: 60,
      currentPage: 1,
      customTabs: [],
      setViewMode: (mode) => set({ viewMode: mode }),
      setShowFilters: (show) => set({ showFilters: show }),
      setFilters: (filters) => set({ filters }),
      setSelectedFile: (file) => set({ selectedFile: file }),
      setActiveTab: (tab) => set({ activeTab: tab }),
      setItemsPerPage: (items) => set({ itemsPerPage: items, currentPage: 1 }),
      setCurrentPage: (page) => set({ currentPage: page }),
      resetFilters: () => set({ filters: defaultFilters }),
      addCustomTab: (tab) =>
        set((state) => ({
          customTabs: [...state.customTabs, tab],
        })),
      removeCustomTab: (tabValue) =>
        set((state) => ({
          customTabs: state.customTabs.filter((tab) => tab.value !== tabValue),
          activeTab:
            state.activeTab === tabValue
              ? "company-files"
              : state.activeTab,
        })),
    }),
    {
      name: "file-explorer-ui",
      partialize: (state) => ({ customTabs: state.customTabs }),
    }
  )
);

